import { VEHICLE_OPTIONS } from '@allocab/allocab-commons-shared-types';
import { VehicleOutput } from '@allocab/allocab-driver-service-types';
import { ArrowsUpToLineSolid, ChildSolid, MobileScreenButtonSolid, PlaneSolid } from '@allocab/allocab-icons';
import { twJoin } from 'tailwind-merge';

import { t } from '../../services/translation/translation';

type Props = {
  vehicle: VehicleOutput;
};

export const VehicleOptionsIndicator = ({ vehicle }: Props) => {
  return (
    <div className="flex items-center gap-2">
      <span title={t('services.airport-badge')}>
        <PlaneSolid
          width={16}
          height={16}
          className={twJoin(
            vehicle.options?.includes(VEHICLE_OPTIONS.AIRPORT_BADGE)
              ? 'fill-green-700 dark:fill-green-600'
              : 'fill-red-700 dark:fill-red-600',
          )}
        />
      </span>
      <span title={t('services.tpe')}>
        <MobileScreenButtonSolid
          width={16}
          height={16}
          className={twJoin(
            vehicle.options?.includes(VEHICLE_OPTIONS.TPE)
              ? 'fill-green-700 dark:fill-green-600'
              : 'fill-red-700 dark:fill-red-600',
          )}
        />
      </span>
      <span title={t('services.booster-seat')}>
        <ArrowsUpToLineSolid
          width={16}
          height={16}
          className={twJoin(
            vehicle.options?.includes(VEHICLE_OPTIONS.BOOSTER_SEAT)
              ? 'fill-green-700 dark:fill-green-600'
              : 'fill-red-700 dark:fill-red-600',
          )}
        />
      </span>
      <span title={t('services.child-seat')}>
        <ChildSolid
          width={16}
          height={16}
          className={twJoin(
            vehicle.options?.includes(VEHICLE_OPTIONS.CHILD_SEAT)
              ? 'fill-green-700 dark:fill-green-600'
              : 'fill-red-700 dark:fill-red-600',
          )}
        />
      </span>
    </div>
  );
};
